import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/inter';
import '@fontsource-variable/geist';
import './styles/index.css';
import { App } from './app/App';
import { installerSignalement } from './shared/incidents/incidents';

/* Une erreur que personne n'a rattrapée s'écrit dans les incidents du bureau. */
installerSignalement();

const racine = document.getElementById('root');
if (!racine) throw new Error('Élément #root absent de index.html.');

createRoot(racine).render(
  <StrictMode>
    <App />
  </StrictMode>
);

/* L'appli installable et utilisable sans réseau : en production seulement. En
   développement, un service worker servirait des fichiers périmés à chaque
   modification. */
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}
